export const open = questionId => ({ type: 'OPEN', questionId });
export const close = questionId => ({ type: 'CLOSE', questionId });

export const setDomain = (dimensions, questionId) => ({
  type: 'SET_DOMAIN',
  questionId,
  ...dimensions,
});